import { Component, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import {SolicitudesService} from '../../../services/user/solicitud/solicitudes.service';
import {CatalogosService} from '../../../services/catalogos.service';
@Component({
  selector: 'app-historial-solicitud',
  templateUrl: './historial-solicitud.component.html',
  styleUrls: ['./historial-solicitud.component.css']
})

export class HistorialSolicitudComponent implements OnChanges {

  @Input() id: string;
  @Output() visual = new EventEmitter<boolean>();
  historiales: any[] = [];

  constructor(public solicitudesService: SolicitudesService,private catalogosService: CatalogosService) { }

  ngOnChanges(): void {
    this.historiales = [];
    this.historiales.push();
    this.visual.emit(true);
    if (this.id) {
      this.catalogosService.getHistorialSolicitud(this.id).subscribe((res: any) => {
        if (res.length !== 0) {
          const historial = res.data;
          historial.forEach(e => {
            this.historiales.push(e.attributes);
          });
          this.visual.emit(false);
        } else {
          this.visual.emit(false);
        }
      });
    }
  }

}
